module.exports = __webpack_public_path__ + "img/029-comoros.11612d47.svg";